import classNames from 'classnames'
import Tappable from 'react-tappable/lib/Tappable'
import Link from 'components/link'
import css from './page-nav.scss'

export default ({ active, children, path }) => {
  return (
    <Tappable
      component="li"
      classes={{
        active: css.activeTappable,
        inactive: css.inactiveTappable,
      }}
      className={classNames({ [css.active]: active })}
    >
      <Link to={path}>{children}</Link>
    </Tappable>
  )
}
